import * as React from 'react';
import { StyleSheet, View } from 'react-native';
import Spacer from 'design-system/Spacer';
import Button from 'design-system/Button';
import { rem } from 'design-system/values';
import { CardView } from 'design-system/CardView';
import { useAppSelector } from 'store/hooks';
import { usePosition } from 'features/invest/hooks';
import InvestBuySellButton from 'features/invest/components/Button';
import { selectTradingAccount } from 'features/invest/reducers/selectors';
import { blockInvestActionOnWeb } from 'features/invest/webGate';
import { useMainStackNavigation } from 'utils/types/navigationV6';
const WalkthroughBuySellView = ({ assetId, }) => {
    const navigation = useMainStackNavigation();
    const [position] = usePosition(assetId);
    const account = useAppSelector(selectTradingAccount);
    const investBalance = account?.account?.availableToInvest;
    const tradingBlockExpiryDate = account?.account?.tradingBlockExpiryDate;
    const scrambled = useAppSelector((store) => store.utils.scrambled);
    const canSell = !!position?.availableToSell;
    const onTopUpPress = React.useCallback(() => {
        if (scrambled)
            return;
        if (blockInvestActionOnWeb('Add money'))
            return;
        navigation.navigate('InvestSelectAccountToTopup');
    }, [scrambled, navigation]);
    const content = React.useMemo(() => {
        if (tradingBlockExpiryDate) {
            return <InvestBuySellButton sell assetId={assetId}/>;
        }
        if (investBalance?.value === 0) {
            return canSell ? (<View style={styles.row}>
          <InvestBuySellButton sell flex assetId={assetId}/>
          <Spacer w={8}/>
          <Button brand flex title="Buy" onPress={onTopUpPress}/>
        </View>) : (<Button brand title="Buy" onPress={onTopUpPress}/>);
        }
        return canSell ? (<View style={styles.row}>
        <InvestBuySellButton sell flex assetId={assetId}/>
        <Spacer w={8}/>
        <InvestBuySellButton buy flex assetId={assetId}/>
      </View>) : (<InvestBuySellButton buy assetId={assetId}/>);
    }, [
        assetId,
        canSell,
        onTopUpPress,
        investBalance?.value,
        tradingBlockExpiryDate,
    ]);
    return (<CardView style={styles.container} noMargin>
      {content}
    </CardView>);
};
export default React.memo(WalkthroughBuySellView);
const styles = StyleSheet.create({
    container: {
        margin: rem(4),
        padding: rem(4),
        marginHorizontal: rem(12),
    },
    row: {
        flexDirection: 'row',
    },
});
